import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, Typography, Popover, message } from "antd";
import { ReactComponent as ArrowRight } from "../../Assets/SVG/select_right.svg";
import { OnBoarding } from "@components/index";
import { ReactComponent as EPodLogo } from "../../Assets/SVG/module_select_e-pod.svg";
import pcLogo from "../../Assets/PNG/module-select-pc.png";
import infoIcon from "../../Assets/PNG/info.png";
import { isPanelUserActive, panelLandingRoute } from "./moduleAccess";

const { Title, Text } = Typography;

/** The info icon beside a module's name; hovering it describes the module. */
const ModuleInfo = ({ text }: { text: string }) => (
  <Popover
    content={<div style={{ maxWidth: 280 }}>{text}</div>}
    trigger="hover"
  >
    <img
      src={infoIcon}
      alt=""
      style={{ width: 18, height: 18, marginLeft: 8, verticalAlign: "middle" }}
    />
  </Popover>
);

export const ModuleSelection: React.FC = () => {
  const navigate = useNavigate();
  const activePanelUsers = localStorage.getItem("inactivePanelUser");
  const activeSpaUsers = localStorage.getItem("inactiveSpaUser");


    const handleSpaNavigation = () => {
    if (activeSpaUsers === "false") {
      message.error("De-activated User");
      return;
    }

    navigate("/dashboard");
  };

  const handlePanelNavigation = async () => {
    /* Re-checked rather than trusting the flag written at login, so someone
       activated in Panel Contract since signing in is not turned away. */
    if (!(await isPanelUserActive())) {
      message.error("De-activated User");
      return;
    }

    /* Admin-only landing pages turned every other panel role away at the door
       — see panelLandingRoute. */
    navigate(panelLandingRoute());
  };

  return (
    <OnBoarding>
      <div>
        <Row>
          <Col span={24}>
            <Typography.Title
              level={3}
              style={{ textAlign: "center" }}
            >
              Welcome to Procurement Online
            </Typography.Title>
          </Col>
          <Col span={24}>
            <Typography.Text style={{ textAlign: "center" }}>Please select one module to proceed</Typography.Text>
          </Col>
          <Col span={24}>
            <Card
              hoverable
              style={{
                width: "100%",
                border: "1px solid #d9d9d9",
                marginTop: "20px",
                borderRadius: "8px",
                cursor: "pointer",
              }}
              onClick={handleSpaNavigation}
            >
              <Row
                align="middle"
                justify="space-between"
                wrap={false}
                gutter={12}
              >
                <Col>
                  <Row
                    align="middle"
                    gutter={14}
                    wrap={false}
                  >
                    <Col>
                      <EPodLogo style={{ width: 40, height: 40, display: "block" }} />
                    </Col>
                    <Col>
                      <Typography.Title
                        level={4}
                        style={{ margin: 0, whiteSpace: "nowrap" }}
                      >
                        e-POD
                        <ModuleInfo text="Request for procurement awards as per the Limit of Authority (LOA)" />
                      </Typography.Title>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <ArrowRight />
                </Col>
              </Row>
            </Card>
          </Col>
          <Col span={24}>
            <Card
              hoverable
              style={{
                width: "100%",
                border: "1px solid #d9d9d9",
                marginTop: "20px",
                borderRadius: "8px",
                cursor: "pointer",
              }}
              onClick={handlePanelNavigation}
            >
              <Row
                align="middle"
                justify="space-between"
                wrap={false}
                gutter={12}
              >
                <Col>
                  <Row
                    align="middle"
                    gutter={14}
                    wrap={false}
                  >
                    <Col>
                      <img
                        src={pcLogo}
                        alt=""
                        style={{ width: 40, height: 40, objectFit: "contain", display: "block" }}
                      />
                    </Col>
                    <Col>
                      <Typography.Title
                        level={4}
                        style={{ margin: 0, whiteSpace: "nowrap" }}
                      >
                        Panel Contract
                        <ModuleInfo text="Request, approve, track, and manage Work Orders under established Panel Contracts" />
                      </Typography.Title>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <ArrowRight />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
    </OnBoarding>
  );
};
